import { render, staticRenderFns } from "./CentrosCustosContainer.vue?vue&type=template&id=16d6471e&scoped=true"
import script from "./CentrosCustosContainer.vue?vue&type=script&lang=js"
export * from "./CentrosCustosContainer.vue?vue&type=script&lang=js"
import style0 from "./CentrosCustosContainer.vue?vue&type=style&index=0&id=16d6471e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d6471e",
  null
  
)

export default component.exports